import { UPDATE_DURATION_TYPE } from '../data/updateDurationType';

function updatedMonthsDuration(durationType, updateDurationMonthsBy) {
  if (durationType === UPDATE_DURATION_TYPE.reduce) {
    return -1 * updateDurationMonthsBy;
  } else {
    return updateDurationMonthsBy;
  }
}

export default updatedMonthsDuration;
